/**
 * Created by zzt on 19/1/9.
 * http配置
 */

import Axios from "axios";

import cookie from "@/storage/cookies.js";
import store from "@/store";
// import router from '@/router'
import { Message } from "element-ui";
// axios 基础配置
// axios.defaults.timeout = 50000;
// axios.defaults.baseURL = process.env.VUE_APP_API;
const instance = Axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 50000,
})

instance.interceptors.request.use(
  config => {
    let token = cookie.cookieRead("token");
    let sign = spiderHack.gernerateStrV1();
    config.headers.sign = sign;
    config.headers.platform = "pc";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // config.headers.platform = 'pc'
      // config.headers.Authorization = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsaWNlbnNlIjoibWFkZSBieSBiMmIiLCJ1c2VyX25hbWUiOiIxODc4NDMxMzU4NSIsInNjb3BlIjpbImFsbCJdLCJyZW1lbWJlcl9tZSI6IlJXRlVXRmROYTFwS1dtdEJlVGhwYzNkR1luZHhaejA5T21kd2NETkVPR0pKZDJwMU16RlBPRXhvWW5ZclZHYzlQUSIsImV4cCI6MTU2MDQ3ODk0MSwiYXV0aG9yaXRpZXMiOlsiUk9MRV9HIl0sImp0aSI6IjYwODUyZmNlLTA3MzktNDVkMy05OWJmLWE1YmYxZGY1YjE2YSIsImNsaWVudF9pZCI6ImdjdHgifQ.rKgs0Eqb61HPFLU2o_luzlpbVYhqYy0fXRzjXw0-v2c`
    }
    if (config.url && config.url.indexOf("/fileUpload") !== -1) {
      return config;
    }
    if (config.url && config.url.indexOf("/v1/front/material") !== -1) {
      return config;
    }
    if (config.url && config.url.indexOf("/car/Release/listRelease") !== -1) {
      return config;
    }
    if (
      config.url &&
      config.url.indexOf("/renl/estate/listRenlEstateSys") !== -1
    ) {
      return config;
    }
    if (
      config.url == `${process.env.VUE_APP_LOGINAPI}/authentication/sv1/user`
    ) {
      config.headers.tag = "member";
    }
    let cookieArea = cookie.cookieRead("area");
    let area = cookieArea ? JSON.parse(cookieArea) : null;
    if (area) {
      if (config.method == "post") {
        // if (!(config.data && config.data.hasOwnProperty("areacode"))) {
        //     config.data = {
        //         areacode: area.id,
        //         ...config.data
        //     }
        // }
        config.data = {
          ...config.data
        };
      } else if (config.method == "get") {
        config.params = {
          // areacode: area.id,
          ...config.params
        };
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// http response interceptors
instance.interceptors.response.use(
  response => {
    if (
      response.headers.isencryption &&
      response.headers.isencryption == 1 &&
      response.data.payload
    ) {
      let param = ["data", "result", "records"];
      let current = param.find(i => i in response.data);
      if (current) {
        let decryptData = spiderHack.decryptJson(response.data.payload);
        let dataType = response.headers.datatype;
        let handler = {
          object: JSON.parse,
          list: JSON.parse,
          long: parseFloat,
          integer: parseFloat,
          boolean: parse =>
            typeof parse == "boolean"
              ? parse
              : typeof parse == "string" && parse == "true"
                ? true
                : false
        };
        response.data[current] = handler[dataType]
          ? handler[dataType](decryptData)
          : decryptData;
      }
    }
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
        case 403:
          Message.error(error.response.data.msg);
          // store.commit('LOGIN_OUT')
          break;
        case 490:
          break;
      }
    }
    return Promise.reject(error.response.data);
  }
);
export default {
  get(url, params, options = {}) {
    return new Promise((resolve, reject) => {
      instance({
        ...options,
        method: "get",
        params,
        url
      }).then(res => {
        resolve(res);
      });
    });
  },
  getLogin(url, params, options = {}) {
    return new Promise((resolve, reject) => {
      instance({
        // ...options,
        method: "get",
        params,
        url,
        withCredentials: true
      }).then(res => {
        resolve(res);
      });
    });
  },
  post(url, data) {
    return new Promise((resolve, reject) => {
      instance({
        method: "post",
        data,
        url
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  postParams(url, params) {
    return new Promise((resolve, reject) => {
      instance({
        method: "post",
        params,
        url
      }).then(res => {
        resolve(res);
      });
    });
  },
  postParamsData(url, params, data) {
    return new Promise((resolve, reject) => {
      instance({
        method: "post",
        params,
        data,
        url
      }).then(res => {
        resolve(res);
      });
    });
  },
  postLogin(url, params) {
    return new Promise((resolve, reject) => {
      instance({
        method: "post",
        headers: { Authorization: "Basic Z2N0eDpnY3R4" },
        url,
        params
      }).then(res => {
        resolve(res);
      });
    });
  },
  put(url, data) {
    return new Promise((resolve, reject) => {
      instance({
        method: "put",
        data,
        url
      }).then(res => {
        resolve(res);
      });
    });
  },
  patch(url, data) {
    return new Promise((resolve, reject) => {
      instance({
        method: "patch",
        data,
        url
      }).then(res => {
        resolve(res);
      });
    });
  },
  delete(url) {
    return new Promise((resolve, reject) => {
      instance({
        method: "delete",
        url
      }).then(res => {
        resolve(res);
      });
    });
  },
  getUser(url, params) {
    return new Promise((resolve, reject) => {
      instance({
        method: "get",
        params,
        url: process.env.VUE_APP_USER + url
      }).then(res => {
        resolve(res);
      });
    });
  }
};
